import {
  handleSettingsLocationSelect,
  handleSettingsMachineSelect,
  handleSettingsSelectAll,
  handleSettingsSpecificLocationSelect,
} from '../../../components/store/slices/settings/force&CommandAndAdminSelectSlice';

export const selectAllIndicatorDispatcherHandler = (
  dispatch,
  name,
  locationList,
  specificLocationList,
  machineList,
  select = true,
) => {

  dispatch(handleSettingsSelectAll({ switch: name, status: select }));
  dispatch(handleSettingsLocationSelect(locationList.newLocationList));
  dispatch(
    handleSettingsSpecificLocationSelect(
      specificLocationList.newSpecificLocationList,
    ),
  );
  dispatch(handleSettingsMachineSelect(machineList.newMachineList));
};
